import React, { useState } from "react";
import axios from "axios";

// 🎨 Fun Color Palette
const COLORS = {
  primary: "#FF77A9",    // Bright Pink
  secondary: "#6EE7B7",  // Mint green for success
  accent: "#60A5FA",     // Soft blue buttons
  warning: "#FCD34D",    // Yellow alerts
  error: "#FB7185",      // Red errors
  background: "#FFF7F9", // Light pink page
  card: "#FFFFFF",       // Card background
  text: "#1F2937",       // Dark gray text
  lightText: "#6B7280",  // Light gray
};

const CheckInPage = () => {
  const [code, setCode] = useState("");
  const [user, setUser] = useState(null);
  const [message, setMessage] = useState("");
  const apiBase = process.env.REACT_APP_API_BASE_URL
  const fetchUser = async () => {
    setMessage("");
    setUser(null);

    if (code.trim().length === 0) {
      setMessage("🖍 Please enter the check-in code!");
      return;
    }

    try {
      const res = await axios.get(`${apiBase}/api/checkin/${code}`);
      setUser(res.data);
      setMessage("🎉 Found the participant! Ready to check in.");
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setMessage("❌ Code not found! Try again?");
      } else {
        setMessage("⚠️ Oops! Something went wrong. Ask for help.");
      }
    }
  };

  const checkInUser = async () => {
    try {
      const res = await axios.post(
        `${apiBase}/api/checkin/${code}/checkin`
      );

      if (res.data.status === "already") {
        setMessage(`🔁 Already checked in at ${res.data.checked_in_at}`);
      } else if (res.data.status === "success") {
        setMessage("✅ Check-in successful! Great job!");
      }

      fetchUser();
    } catch (err) {
      setMessage("⚠️ Uh-oh! Something went wrong.");
    }
  };

  const buttonStyle = (color) => ({
    width: "100%",
    padding: "16px",
    marginTop: "15px",
    fontSize: "18px",
    fontWeight: "700",
    borderRadius: "14px",
    border: "none",
    cursor: "pointer",
    background: color,
    color: "white",
    boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
    transition: "transform 0.15s ease",
  });

  const inputStyle = {
    width: "100%",
    padding: "16px 18px",
    marginBottom: "15px",
    fontSize: "18px",
    borderRadius: "14px",
    border: `2px solid #FBB6CE`,
    backgroundColor: "#FFF0F6",
    color: COLORS.text,
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: COLORS.background,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "30px 10px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "480px",
          padding: "20px",
        }}
      >
        {/* Event Title */}
        <h1
          style={{
            textAlign: "center",
            fontSize: "28px",
            fontWeight: "800",
            color: COLORS.primary,
            marginBottom: "20px",
          }}
        >
          🎉 Udyog Connect Tech Summit 2025
        </h1>

        {/* Check-In Card */}
        <div
          style={{
            background: COLORS.card,
            borderRadius: "20px",
            padding: "25px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              color: COLORS.accent,
              fontSize: "24px",
              fontWeight: "700",
              marginBottom: "20px",
            }}
          >
            Participant Check-In
          </h2>

          <input
            type="text"
            placeholder="Enter Participant Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={inputStyle}
          />

          <button onClick={fetchUser} style={buttonStyle(COLORS.primary)}>
            🔍 Find Participant
          </button>

          {message && (
            <p
              style={{
                marginTop: "20px",
                padding: "12px",
                borderRadius: "12px",
                textAlign: "center",
                fontWeight: "600",
                fontSize: "16px",
                color: COLORS.text,
                backgroundColor:
                  message.includes("successful") || message.includes("Ready")
                    ? COLORS.secondary
                    : COLORS.error,
              }}
            >
              {message}
            </p>
          )}

          {user && (
            <div
              style={{
                marginTop: "25px",
                padding: "20px",
                borderRadius: "18px",
                backgroundColor: "#FFF0F6",
                border: "2px solid #FBB6CE",
              }}
            >
              <h3
                style={{
                  color: COLORS.primary,
                  marginBottom: "12px",
                  fontSize: "22px",
                  fontWeight: "700",
                }}
              >
                {user.first_name} {user.last_name}
              </h3>

              <p style={{ color: COLORS.lightText }}>📧 Email: {user.email}</p>
              <p style={{ color: COLORS.lightText }}>📱 Mobile: {user.mobile}</p>
              <p style={{ color: COLORS.lightText }}>
                🏷️ Category: {user.participant_category}
              </p>

              <p
                style={{
                  fontWeight: "700",
                  marginTop: "15px",
                  fontSize: "16px",
                }}
              >
                Status:{" "}
                {user.checked_in === 1 ? (
                  <span style={{ color: COLORS.secondary }}>✔ Checked-In</span>
                ) : (
                  <span style={{ color: COLORS.error }}>❌ Not Checked-In</span>
                )}
              </p>

              {user.checked_in === 0 && (
                <button
                  onClick={checkInUser}
                  style={buttonStyle(COLORS.accent)}
                >
                  ✅ Mark as Checked-In
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckInPage;
